import React from 'react';

import { AsyncComponent } from '../../index';

import * as PlaylistT3Constants from './constants';
import * as D from './deps';
import PlaylistT3Reducer from './reducer';
import Watchers from './sagas/watchers';
import utils from './utils';

export default D.createDomainModule({
  name: PlaylistT3Constants.DOMAIN_NAME,
  components: {
    BackstagePlaylist: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-playlist" */ './components/BackstagePlaylist/BackstagePlaylist',
            )
          }
        />
      );
    },
  },
  utils,
  reducer: PlaylistT3Reducer,
  onStart() {
    this.registeredHandlers = D.registerHandlers(Watchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
